module.exports = __webpack_public_path__ + "static/img/youtube.19520e4f.svg";